import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/Oluwole Ogunlade.jpg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/adaobi.jpg";
import Instructor2 from "../../../../../assets/images/png/courses/instructors/azeta.webp";
import Instructor3 from "../../../../../assets/images/png/courses/instructors/olatunji.webp";

import Testimony3 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/adetola.webp";
import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/awele.webp";
import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/evelyn.webp";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import BusinessImage from "../../../../../assets/images/svg/business.svg";
import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import ProductMgtPreview from "../../../../../assets/images/jpeg/productMgtPreview.jpg";

export const productManagementAcceleratorEurope = {
  id: 1,
  tag: "FOR PROFESSIONALS",
  title: "Product Management Bootcamp",
  description: `
  This training is designed by top professionals to help you fast-track 
  your career in Product Management. Designed for those that 
  already have their foot in the industry and want to fast-track their career 
  through in-depth knowledge and also want to build a leading 
  industry relationship that converts to jobs.   
    `,
  duration: "12 Weeks",
  durationDetail: "12-week integrated program",
  downloadBrochureUrl:
    "https://drive.google.com/file/d/1HnlMkwR7mBOlYd05QFyeyE5mf5OSBbOg/view?usp=sharing",

  courseFormUrl: "courses/product-management-and-design-bootcamp/fill-form",

  jobTitle: "Product Manager",

  kickoffDate: "December 2",
  kickoffTime: <>Saturday 4:00 PM -8:00 PM (GMT +1)</>,

  testimonial: {
    image: TestimonialImage,
    name: "Oluwole Ogunlade",
    role: "Growth Consultant, Cross-border Payment Processor",
    testimony: `
    I got the best experience from the Utiva Product Management 
    program, it was a hands-on learning experience as we were 
    splitted into groups and given real life business cases to 
    work on as a team. For me I enjoyed the expertises of the 
    facilitators and the quality of materials we were given. 
    Above all the community style of learning is everything.
`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Fast Track Your Career In Product Management; Learn Product Management Best Practices Live, Led by Experienced Product Leaders`,
    desc: `
    Product Managers are responsible for owning a product at every stage of 
    its life cycle, bringing it from ideation to market, and ensuring 
    success. Balance business viability, technical feasibility, and 
    customer desire to lead products and features toward long-term 
    success. Learn from leading experts in the industry and develop 
    the capacity to drive successful projects. Balance business 
    viability, technical feasibility, 
    and customer desire to lead products and features toward 
    long-term success. Learn from a seasoned expert.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Product Management Fundamentals",
      unitTag:
        "Product knowledge, Tech industry analytics, Customer research, Customer & Market Research, Product Strategy, Team Leadership",
      unitDescription: `
      You'll start this journey by learning directly from leaders on how 
      the product management industry is designed and structured, 
      and connect that class to the foundations of product management 
      which includes the three pillars of PM: Product, Customers and Processes. 
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Knowing Your Customers",
          featureDescription: `You will learn to conduct customer research as a 
          Product Manager and define your target customers as personas to 
          inform your customer-centric product management strategy.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "What is the Lean Product Process",
          featureDescription: `Learn the core principles of Lean, centred 
          around eliminating waste, remaining flexible, ensuring Agile delivery, and more.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Unlocking the Product Management Opportunities",
          featureDescription: `Learn to identify the problem space versus the solution 
          space to help structure your thinking, capitalize 
          on opportunities, and inform your product management iterations.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Develop Product Management Hypotheses",
          featureDescription: `Incorporate everything you learn into a product management vision 
          and value proposition hypothesis that will form the foundation of your product management strategy.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Design Thinking",
      unitTag: "Design thinking, Empathy mapping, User research, User Persona",
      unitDescription: `
      You will start by applying design thinking practices to product development 
      and buy-in strategies, allowing you to understand the real-world market 
      further, maximize positive outcomes and customers' thought processes. 
      As you complete this Product Management certification, you'll learn how 
      to perform opportunity and customer discovery, and how to translate 
      your research insights into a product vision and 
      value proposition hypothesis that can be applied to 
      software product management and more.
        `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Design Thinking ",
          featureDescription: `Design thinking is a process for solving problems by 
          prioritizing the consumer's needs above all else. It relies on observing, 
          with empathy, how people interact with their environments, and employs 
          an iterative, hands-on approach to creating innovative solutions
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Empathy Map",
          featureDescription: `An Empathy Map allows us to sum up our learning from 
          engagements with people in the field of design research. The map provides 
          four major areas on which to focus our attention, 
          thus providing an overview of a person’s experience. 
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "User Research",
          featureDescription: `You use user research to inspire your design, to evaluate your 
          solutions, and measure your impact. User research (and other kinds of 
            research) is often divided into quantitative and qualitative methods.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "User Persona",
          featureDescription: `User personas are archetypical users whose goals a
          nd characteristics represent the needs of a larger group of users`,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Product Design",
      unitTag:
        "Product Prototyping, Wireframing, User Testing, Iterative Product Development",
      unitDescription: `
      Once the problem has been defined and a market opportunity has been 
      identified, it is important to create a solution that is desirable by 
      its users. Bring an idea through concept, design, and user validation, 
      as well as create a spec to hand off to engineering for development. Use design 
      thinking methodologies to diverge in order to explore ideas, 
      and then ultimately focus on and converge on a single idea. 
        `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Intro to Design Sprint",
          featureDescription: `Learn how to describe the purpose and process of a 
          Design Sprint and identify good candidates for a Design Sprint, learn how 
          to plan and involve necessary stakeholders in a Design Sprint, and 
          differentiate between the responsibilities of the Product Manager and Designer roles.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Understand",
          featureDescription: `Describe the Understand phase of the Design Sprint, 
          describe how lightning talks, interviews, and competitive analysis can 
          be used as an input during the Understand phase, use the “How Might We” 
          method to identify opportunities, utilize the “Rose Bud Thorn” 
          method to classify things as positive, negative, or opportunities, 
          and apply Affinity Mapping to identify thematic insights.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Define",
          featureDescription: `Describe the Define phase of the Design Sprint, 
          define success metrics using the HEART framework, explain the difference 
          between goals, signals, and metrics, and Craft Design 
          Principles • Write a Future Press Release.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Sketch",
          featureDescription: `Describe the Sketch phase of the Design Sprint, Use the 
          Crazy 8’s method to brainstorm ideas through sketching, 
          Facilitate a process for sharing and voting on sketches 
          within the team, and create a more detailed, 
          in-depth Solution Sketch that contains at least 3 frames.
          `,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Decide",
          featureDescription: `Describe the Decide phase of the Design Sprint, 
          Identify assumptions behind ideas and formulate questions about 
          them, create a Decision Matrix to narrow down ideas to those 
          worth pursuing, and represent perspectives from a wider audience using Thinking Hats.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Prototype",
          featureDescription: `Describe the Prototype phase of the Design Sprint, 
          create a storyboard to map out a plan for your prototype, 
          learn how to utilize different types of 
          prototyping, create high fidelity, interactive prototype, 
          and apply best practices for creating prototypes.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Validate",
          featureDescription: `Describe the Validate phase of the Design Sprint, 
          create plans and data collection processes for a user study, run a 
          user study and interview users, and conduct a feasibility 
          discussion with an engineer
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Next Steps ",
          featureDescription: `Describe the benefits of iteration and identify when 
          iteration is appropriate, evangelize your idea across cross-functional 
          development teams, and create documentation for the engineering team.
          `,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Run a Design Sprint ",
          featureDescription: `Take a problem through a design sprint to develop 
          a concept, create a prototype, bring your concept through user 
          testing, and then prepare to hand off your concept to the engineering team.
          `,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Building and Refining Products",
      unitTag:
        "Product Prototyping, Wireframing, User Testing, Iterative Product Development",
      unitDescription: `
      The best products are developed through iterative product management 
      processes that allow businesses to experiment and learn while constantly 
      improving the product. Learn how Product Managers apply wireframing, 
      testing, prioritization, and road mapping as part of their product strategy 
      to build effective products within their product management program.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Discover the Essential Role Wireframing Plays in Product Management",
          featureDescription: `Learn how a Product Manager uses wireframing as part of rapid 
          prototyping to design more effective, customer-centric products.`,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Learn the Step-by-Step Testing Plan to Inform Your Product Efforts",
          featureDescription: `Iterative development requires effective testing. 
          Learn the steps to set up and execute valuable tests, 
          including usability tests, that drive your product management iterations.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Define Priorities and Your Product Management Roadmap",
          featureDescription: `By applying time-tested prioritization strategies, 
          learn how a Product Manager focuses on the most important aspects of any product. Learn to 
          develop a product management roadmap to drive successful product execution.
              `,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Agile Methodology & Scrum Framework",
      unitTag:
        "Agile Methodology, Product Planning, MVPs, Agile Project Management",
      unitDescription: `
      Go deeper into Agile development and Lean methodologies and discover 
      how they work in tandem to enable product management teams to move 
      quickly, and rapidly iterate toward product-market fit and an effective 
      product. Learn how Product Managers work with development teams through 
      the details of Agile development practices, including the core Agile principles, 
      Agile variations, and how to prepare user stories and complete story mapping.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Drive the Development of Efficient MVPs",
          featureDescription: `Learn how Product Managers apply the Build-Measure-Learn 
          framework of Lean to develop efficient Minimum Viable Products (MVPs) 
          that test your product hypothesis and allow you to iterate toward an effective 
          product – a common practice in digital product management.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Learn to Lead Development with Agile Methodologies",
          featureDescription: `Learn why Product Managers leverage Agile 
          methodologies and explore how to incorporate them into your 
          product development in order to deliver better solutions faster.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Discover the Pivot: What It Is and When to Use It",
          featureDescription: `The concept of a pivot, informed by Lean methodologies, 
          has been essential in the development of many product innovations. 
          As a Product Manager, learn how to apply pivots to your product 
          management process through exploring examples of 
          successful pivots that could apply throughout the product life cycle.
              `,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Product Strategy",
      unitTag: "Vision and Strategy, Pitch and Product Value Communication",
      unitDescription: `
      The most effective products start with a comprehensive market-based, 
      insight-driven strategy. Understand the role that product managers 
      play during product development, with a focus on activities that 
      happen early in the product development cycle. Learn how to identify 
      the right problems to solve through market research, target user 
      definition, and market sizing. Create a compelling vision and 
      strategy that will set up the team to solve those problems. Understand how to 
      communicate effectively to get people excited and bought into your ideas.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Vision & Strategy",
          featureDescription: `Define and craft compelling vision for a new 
          product, identify strategic areas to invest in based on organizational 
          goals and competitive analysis, build a Business Model Canvas for a 
          product opportunity, understand the importance of defining a minimum 
          viable product (MVP), and define key performance 
          indicators (KPIs) that align product strategy to organizational goals`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Project: Pitch a Product Vision ",
          featureDescription: `Develop and deliver a market-based, insight-driven 
          pitch for a new product that is targeted to executive stakeholders.
          `,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Metrics for Product Managers",
      unitTag: "Metrics",
      unitDescription: `
      Metrics is a vital tool for achieving your product strategy. 
      Using the proper metrics will let you build the right goals 
      into your product strategy and let you know how well you are 
      achieving those goals. In this course, you will learn how to 
      use metrics to achieve your product strategy goals, how to 
      build a metric-driven product strategy, key concepts for getting 
      the most value from your metrics, how to choose metrics to help 
      you shape your product strategy, and how to measure how successfully customer needs are being met.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Best Practices for Metrics",
          featureDescription: `Recognize best practices for choosing metrics that support the goals of your product strategy`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Values of Data and Metrics",
          featureDescription: `Identify key concepts for getting the most value from your metrics
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Connecting Metrics to Strategy",
          featureDescription: `Sequence the steps for building a metric-driven product strategy
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Business metrics",
          featureDescription: `Recognize the definitions of important business metrics
          `,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Customer Metrics",
          featureDescription: `Recognize the definitions of the important customer metrics
          `,
        },
      ],
    },
    {
      unitId: 8,
      unitTitle: "Product Launch",
      unitTag:
        "Product Positioning, Go-To-Market Strategy, Pricing Strategy, Product Analytics",
      unitDescription: `
      When a product has completed development, it's time for Product Managers 
      to prepare for launch. Explore product marketing strategies used by 
      Product Managers to help drive a successful launch, as well as the 
      business analytics needed to monitor the launch 
      and ongoing growth as part of a complete product management program.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Learn Successful Product Marketing",
          featureDescription: `Understand what product marketing is and how to develop your positioning, 
          messaging, and brand strategy to effectively market your product.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Apply Effective Revenue Models and Pricing Strategies",
          featureDescription: `Explore common revenue models and the pricing strategies that work 
          with them to drive value for both your business and your customers.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Implement Analytics for Data-Driven Decision Making",
          featureDescription: `Discover the key stages of Lean analytics to help track 
          both the success of your launch and ongoing growth and engagement.
          `,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "Fast-Track Into Jobs",
      unitTag: "LinkedIn optimisation, Cover letter, CV, Interview coaching",
      unitDescription: `
      This class is designed as a job workshop. The core is to train our 
      students on all the areas of job prospecting that are needed to land a job in 3 months. 
          `,
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Adaobi Igwe-Okerekeocha",
      coachRole: "Senior Program Manager, Microsoft",
    },

    {
      coachId: 2,
      coachImage: Instructor2,
      coachName: "Enahoro Azeta",
      coachRole: "Product Manager, Africhange",
    },
    {
      coachId: 3,
      coachImage: Instructor3,
      coachName: "Olatunji Obaoye",
      coachRole: "Senior Product Manager, Africhange",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Lectures & Lab",
      modelDescription: (
        <>
          <ul className="list-outside ml-3 space-y-2 list-disc">
            <li>Weekend classes</li>
            <li>Focus on 6 major themes of PM </li>
            <li>Delivered by industry leaders</li>
            <li>Multiple class interactions</li>
          </ul>
        </>
      ),
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Projects and Coaching",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Build a product with a complete team</li>
          <li>Learn to use multiple tools on real product</li>
          <li>Get real-time feedback from coaches</li>
        </ul>
      ),
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Virtual Apprenticeship",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>2 month virtual apprenticeship</li>
          <li>Work with Product Managers</li>
          <li>Product case room with 5 senior PMs</li>
        </ul>
      ),
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Job and Career Coaching",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>1 month coaching on jobs</li>
          <li>Start applying to roles</li>
          <li>Demo sessions on interviews</li>
        </ul>
      ),
    },
    {
      modelId: 5,
      modelIcon: BusinessImage,
      modelTitle: "A Life Time Access",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Access to our recorded classes</li>
          <li>Access to the Utiva community </li>
        </ul>
      ),
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "https://www.linkedin.com/in/evelyn-ebo/",
      image: Testimony1,
      firstname: "Evelyn",
      lastname: "Ebo",
      company: "Product Operations Specialist, Advans Nigeria",
      testimony: `
      Utiva has impacted my career progression in a positive 
      way as the changes in the last couple of months have been rapid. 
      I've had to change roles from a business-oriented role to a
       digital-oriented role. I've had opportunities to implement my 
       learnings in real-life scenarios, had a role change to a Digital role, scholarships, 
      and also volunteering roles. I feel fulfilled implementing my passion
      `,
    },

    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Noella",
      lastname: "Onwuachi",
      company: "Product Manager, Robert and John ltd",
      testimony: `
      Utiva improved my skills as a product manager, especially 
      as someone who did not have a tech background, 
      built my leadership skills, and increased my confidence in myself.
      `,
    },

    {
      id: 3,
      linkedIn: "https://www.linkedin.com/in/olasunkanmi-adetola-a317b132/",
      image: Testimony3,
      firstname: "Olasunkanmi",
      lastname: "Adetola",
      company: "Product Manager, Errandpay",
      testimony: `
      Utiva has positively and gave me the leverage to transition from 
      a banking operations role to a Product Management role.
      `,
    },
  ],

  portofolio: {
    title: "Build and Showcase Your Product Portfolio Project",
    description: `
    To earn your Product Management certification, showcase everything you've 
    learned in a pitch presentation where experts evaluate your new product 
    management skill set. Every week, you'll be provided with clear steps to 
    iteratively develop your final project. By the end of the course, 
    you'll have created a formal product management 
    proposal presentation, demonstrating your end-to-end product, implementation, and launch strategy.
      `,
    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Product Management Certification",
    description: `
    Upon completing Utiva's Product Management Course, you'll receive an 
    industry-recognized, professional Product Management certification 
    to share with your network and showcase all that you've learned. 
    Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  videoTestimonial: "https://www.youtube.com/embed/M3EwmTtWvLo",
  videoPreviewImage: ProductMgtPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Cloud Bootcamp",
      courseDescription: `This training is designed to help you 
      move into a new tech job within 3 months. That is our goal 
      and hope you are ready for this. You learn the latest 
      skills of the Cloud Developer using the Microsoft Azure 
      program, you will learn how to deploy, build, migrate, 
      and monitor applications on Azure. `,
      courseUrl: "/courses/cloud-bootcamp",
    },
  ],
};
